// import image files (adjust paths to your structure)  
import img183 from "../assets/products/18kg-3.png"; 
import img322 from "../assets/products/320-2.png";
import img323 from "../assets/products/320-3.png"; 
import img642 from "../assets/products/640-2.png";
import img643 from "../assets/products/640-3.png";
import icon from '../assets/icons.webp';

const products = [
 
  {
    id: '100-sesame-tahini',
    title: "320G Glass Jar",
    description:
      "Holland Tahini is our delicious answer to healthy eating through the pure power of sesame seeds. Holland Tahini’s 100% Sesame Butter is our delicious answer to healthy, nutritious, and creative eating with the pure power of tahini. Retail-friendly 320 g jar. Small-batch roasted sesame, stone-milled for a smooth, pourable texture. Perfect for dressings, dips, and baking. No additives; separation is natural—stir before use.",
    images: [img322,img323,img322],
    highlightImage: [icon],
    recipe: {
      title: "Baba Ganoush",
      description:
        "A smoky eggplant dip balanced by tahini’s nutty creaminess.",
      ingredients: [
        "2 medium eggplants",
        "2 tbsp tahini",
        "2 tbsp olive oil",
        "Juice of 1 lemon",
        "1 garlic clove",
        "Salt to taste",
      ],
      instructions: [
        "Roast eggplants (whole) in the oven at 200°C until soft and charred (30–40 min).",
        "Scoop out the flesh and blend with tahini, lemon juice, garlic, and olive oil.",
        "Season with salt and drizzle with olive oil before serving.",
      ],
      quickTip:
        "For extra smokiness, char the eggplants directly over a flame before blending.",
    },
  },
  {
    id: 'product-3',
    id: "640-glass-jar",
    title: "640G Glass Jar",
    description:
      "Holland Tahini is our delicious answer to healthy eating through the pure power of sesame seeds. Holland Tahini’s 100% Sesame Butter is our delicious answer to healthy, nutritious, and creative eating with the pure power of tahini. Value-size 640 g jar for home cooks and small kitchens. Same pure tahini—100% sesame seeds with deep, nutty notes. Great for weekly meal prep: sauces, cookies, and marinades.",
    images: [img642,img643,img642],
    highlightImage: [icon],
    recipe: {
      title: "Falafel with Tahini Sauce",
      description:
        "Crispy falafels meet a tangy tahini sauce for the perfect bite.",
      ingredients: [
        "3 tbsp tahini",
        "Juice of 1 lemon",
        "1 garlic clove (minced)",
        "3–4 tbsp water (to thin)",
        "Salt to taste",
      ],
      instructions: [
        "Whisk tahini, lemon juice, garlic, and water until smooth and pourable.",
        "Season with salt.",
      ],
      quickTip:
        "Use this sauce not just for falafel, but also as a drizzle over wraps, salads, or grilled veggies.",
    },
  }, {
    id: 'classic-tahini-16oz',
    title: "18kg Plastic Bucket",
    description:
      "Holland Tahini is our delicious answer to healthy eating through the pure power of sesame seeds. Holland Tahini’s 100% Sesame Butter is our delicious answer to healthy, nutritious, and creative eating with the pure power of tahini. Food-service size tahini in a food-grade HDPE bucket. Stone-milled 100% hulled sesame seeds—no additives or preservatives. Ideal for restaurants, hummus makers, and catering. Naturally vegan and gluten-free. Stir well as natural oil separation may occur.",
    images: [img183],
    highlightImage: [icon],
    recipe: {
      title: "Hummus",
      description:
        "A creamy, protein-packed dip made with chickpeas and tahini — a true classic.",
      ingredients: [
        "1 can (400g) chickpeas, drained and rinsed",
        "3 tbsp tahini",
        "2 tbsp olive oil",
        "Juice of 1 lemon",
        "1 garlic clove",
        "Salt to taste",
        "2–3 tbsp water (for consistency)",
      ],
      instructions: [
        "Blend chickpeas, tahini, lemon juice, garlic, and olive oil until smooth.",
        "Add water slowly to reach your preferred creaminess.",
        "Season with salt and drizzle with olive oil before serving.",
      ],
      quickTip:
        "Serve with warm pita or fresh veggies. Keeps in the fridge for 3–4 days.",
    },
  }
];

export default products;
